const NAME = "LABOR_UNIONS";

export default NAME;
